module.exports = __webpack_public_path__ + "media/02_ASANBUDAPEST-Atmosphere02.0c6a0b22.mp3";